<template>
  <div class="hello">

    <div ref="home1" class="homeImg">
      <el-carousel indicator-position="none" :height="imageHeight"  arrow="never">
        <el-carousel-item v-for="item in itemData.content.homeImg" :key="item.indexImg" >
          <img :src="item.urlDate" alt="" class="image">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="homeIntroduction">

      <div class="introduction">
        <div class="introduction_left">
          <div class="introduction_left_1">
            <img :src="itemData.content.homeIntroduction.imgUrl.urlDate"  class="introduction_image" >
          </div>
          <div class="introduction_left_2">
            {{itemData.content.homeIntroduction.text1.content}}
          </div>
        </div>
        <div class="introduction_right">
          <div class="introduction_right_1">
            {{itemData.content.homeIntroduction.text2.content}}
          </div>
          <div class="introduction_right_2">
            <div class="introduction_right_2_1">
              {{itemData.content.homeIntroduction.text3.content}}

            </div>
            <div class="introduction_right_2_1">
              {{itemData.content.homeIntroduction.text4.content}}

            </div>
          </div>
          <div class="introduction_right_3">
<!--            <div class="introduction_right_31"  @click="aboutUs()">-->
<!--              <div class="introduction_right_3_1">-->
<!--                {{itemData.content.homeIntroduction.text5.content}}-->
<!--              </div>-->
<!--            <div ><i class="el-icon-right introduction_right_3_2"></i></div>-->
<!--            </div>-->
          </div>



        </div>
      </div>
    </div>

    <div class="homeProduct">
      <div class="introduction">
      <div class="homeProduct_left">
        <div class="homeProduct_left_1">
          {{itemData.content.homeProduct.text2.content}}
        </div>
        <div class="homeProduct_left_2">
          <div class="homeProduct_left_2_1">
            {{itemData.content.homeProduct.text3.content}}
          </div>
          <div class="homeProduct_left_2_1">
            {{itemData.content.homeProduct.text4.content}}

          </div>

        </div>
        <div class="homeProduct_left_3">
          <div class="homeProduct_left_31" @click="toPath('/product')">
            <div ><i class="el-icon-right homeProduct_left_3_2"></i></div>
          </div>
        </div>
      </div>
      <div class="homeProduct_right">
<!--        <div class="homeProduct_left_i" @click="leftYYProduct" >-->
<!--          <i class="el-icon-arrow-left homeProduct_i"></i>-->
<!--        </div>-->
        <div class="homeProduct_right_1" v-for="item in itemData.content.homeProduct.img"  @click="toPath('/product')">
          <div class="homeProduct_right_1_1">
            <img :src="item.imgUrl.urlDate"  class="homeProduct_image" >
          </div>
          <div class="homeProduct_right_1_2">
            {{item.itemText1.content}}
          </div>
          <div class="homeProduct_right_1_3">
            {{item.itemText2.content}}
          </div>

        </div>
<!--        <div class="homeProduct_right_i" @click="rightYYYYProduct" >-->
<!--          <i class="el-icon-arrow-right homeProduct_i"></i>-->
<!--        </div>-->
      </div>
        </div>
    </div>

    <div class="homeProgramme">
      <div class="introduction">
      <div class="homeProgramme_left">
<!--        <div class="homeProgramme_left_i" @click="rightYY" >-->
<!--          <i class="el-icon-arrow-left homeProduct_i"></i>-->
<!--        </div>-->
        <div class="homeProgramme_left_1" v-for="item in itemData.content.homeProgramme.img" :style="{marginLeft:item.left.content}"  @click="toPath('/solution?path='+item.path.content)">
          <div class="homeProduct_right_1_1">
            <img :src="item.imgUrl.urlDate"  class="homeProduct_image" >
          </div>
          <div class="homeProduct_right_1_2">
            {{item.itemText1.content}}
          </div>
          <div class="homeProduct_right_1_3">
            {{item.itemText2.content}}
          </div>

        </div>
<!--        <div class="homeProgramme_right_i" @click="rightYY" >-->
<!--          <i class="el-icon-arrow-right homeProduct_i"></i>-->
<!--        </div>-->
      </div>
      <div class="homeProgramme_right">
        <div class="introduction_right_1">
          {{itemData.content.homeProgramme.text2.content}}
        </div>
        <div class="introduction_right_2">
          <div class="introduction_right_2_1">
            {{itemData.content.homeProgramme.text3.content}}
          </div>
          <div class="introduction_right_2_1">
            {{itemData.content.homeProgramme.text4.content}}

          </div>

        </div>
        <div class="homeProgramme_right_3">
          <div class="homeProgramme_right_31" @click="toPath('/solution')">
            <div ><i class="el-icon-right homeProduct_left_3_2"></i></div>
          </div>
        </div>
      </div>
        </div>
    </div>

    <div class="homeNews">
      <div class="news">
        <div class="news_tatil">
          {{itemData.content.homeNews.text1.content}}
        </div>
        <div class="news_tatil_detail">
          {{itemData.content.homeNews.text2.content}}
        </div>
        <div class="news_content">
          <div class="news_content_left" @click="toPath('/newsItem?path='+itemData.content.homeNews.content1.path.content)">
            <div class="news_content_left_1">
              <img :src="itemData.content.homeNews.content1.imgDate.content"  class="introduction_image" >
            </div>
            <div class="news_content_left_2">
              {{itemData.content.homeNews.content1.text1.content}}
            </div>
            <div class="news_content_left_3">
              {{itemData.content.homeNews.content1.text2.content}}

            </div>

          </div>
          <div class="news_content_right">
            <div class="news_content_right_1">
              <img :src="itemData.content.homeNews.content2.imgDate.content"  class="introduction_image" >
            </div>
            <div class="news_content_right_2">
              {{itemData.content.homeNews.content2.text1.content}}
            </div>
            <div class="news_content_right_3" @click="toPath('/newsItem?path='+itemData.content.homeNews.content2.path.content)">
              {{itemData.content.homeNews.content2.text2.content}}

            </div>
            <el-divider class="news_content_right_4"></el-divider>
            <div class="news_content_right_5">
              {{itemData.content.homeNews.content3.text1.content}}
            </div>
            <div class="news_content_right_6" @click="toPath('/newsItem?path='+itemData.content.homeNews.content3.path.content)">
              {{itemData.content.homeNews.content3.text2.content}}
            </div>
            <el-divider class="news_content_right_7"></el-divider>
            <div class="news_content_right_8">
              <div class="news_content_right_8_1" @click="toPath('/news2')">
                <div ><i class="el-icon-right news_content_right_8_1_1"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="homeLeave">
      <div class="leave">
        <div class="homeLeave_left">
          <div class="homeLeave_left_1">
            {{itemData.content.homeLeave.text1.content}}
          </div>
          <div class="homeLeave_left_2">
            {{itemData.content.homeLeave.text2.content}}

          </div>
          <div class="homeLeave_left_3">
            <i class="el-icon-phone homeLeave_left_3_2"></i>
            <div class="homeLeave_left_3_1">
              {{itemData.content.homeLeave.text3.content}}

            </div>
          </div>
          <div class="homeLeave_left_4">
            <i class="el-icon-message homeLeave_left_3_2"></i>
            <div class="homeLeave_left_4_1">
              {{itemData.content.homeLeave.text4.content}}
            </div>
          </div>


        </div>
        <div class="homeLeave_right">
          <div class="homeLeave_right_1">
            <el-input v-model="homeLeaveData.userName" :placeholder="itemData.content.homeLeavePlace.text1"></el-input>
          </div>
          <div class="homeLeave_right_2">
            <el-input v-model="homeLeaveData.phone" :placeholder="itemData.content.homeLeavePlace.text2"></el-input>
            <el-input v-model="homeLeaveData.wechat" :placeholder="itemData.content.homeLeavePlace.text3" style="margin-left: 5px"></el-input>

          </div>
          <div class="homeLeave_right_3">
            <el-input
              type="textarea"
              :rows="5"
              :placeholder="itemData.content.homeLeavePlace.text4"
              v-model="homeLeaveData.message">
            </el-input>
          </div>

          <div class="homeLeave_right_4">
            <button class="homeLeave_right_4_1" @click="commit">{{itemData.content.homeLeavePlace.commit}}</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Data } from './js/home.js';
export default {

  name: "home",
  data() {
    return {
      dataAll:Data,
      itemData:{},
      imageHeight: "860px",
      screenWidth:0,
      homeLeaveData:{
        userName:"",
        phone:"",
        wechat:"",
        message:""
      }
    }
  },
  created() {
  },
  mounted() {
    let that = this;
    console.log(that.itemData);

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      console.log(itemData.type);
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        console.log(that.itemData);
        break;
      }
    }
    this.setWH();
    window.addEventListener('resize', this.setWH);


  },
  methods:{
    setWH() {
      let that = this;
      that.screenWidth = window.innerWidth;
      console.log("hh"+that.screenWidth);

      let hight = that.screenWidth /1920 *860;
      console.log("hh"+hight);
      that.imageHeight = hight + "px";
    },
    leftYYProduct(){

    },
    aboutUs(){
      this.$router.push('/aboutUs?path=bt1');
    },
    toPath(path){
      this.$router.push(path);
    },
    commit(){
      this.$axios
        .post('/acl/user/addUserMsg', {
          userName: this.homeLeaveData.userName,
          phone: this.homeLeaveData.phone,
          wechat:this.homeLeaveData.wechat,
          message:this.homeLeaveData.message
        })
        .then(successResponse => {
          if (successResponse.data.code === "200") {

            this.$notify({
              title: '成功',
              message: '提交成功',
              type: 'success'
            });
            this.homeLeaveData.userName="";
            this.homeLeaveData.phone="";
            this.homeLeaveData.wechat="";
            this.homeLeaveData.message="";
          } else {
            this.$notify.error({
              title: '失败',
              message: '提交失败，请重新提交'
            });
          }
        })
        .catch(failResponse => {
          this.$notify.error({
            title: '失败',
            message: '提交失败，请重新提交'
          });
        })
    }
  }
  ,
  beforeDestroy() {
    window.removeEventListener('resize', this.setWH); // 移除监听器
  }
}
</script>

<style scoped>
.homeLeave_right_4_1{
  font-family: SourceHanSansCN;
  width: 100%;
  background: #014ED5;
  border-radius: 24px 24px 24px 24px;
  color: #FFFFFF;
  aspect-ratio: 560/48;
  border: none !important;
}
.homeLeave_right_4{
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right_3{
  height: 120px;
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right_2{
  height: 40px;
  display: flex;
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right_1{
  height: 40px;
  margin-top: 24px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right{
  width: 53.5%;
}
.homeLeave_left_3_2{
  font-size: 56px;
}
.homeLeave_left_4_1{
  font-family: SourceHanSansCN;
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 3px;
}
.homeLeave_left_4{
  margin-top: 24px;
  display: flex;
  align-items: center;
}
.homeLeave_left_3_1{
  font-family: SourceHanSansCN;
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 3px;

}
.homeLeave_left_3{
  display: flex;
  margin-top: 28px;
  align-items: center;

}
.homeLeave_left_2{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 20px;
  color: #454545;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.homeLeave_left_1{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.homeLeave_left{
  width: 46.5%;
  background-color: #FFFFFF;
}
.leave{
  width: 78%;
  display: flex;
}
.homeLeave{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  margin-top: 120px;
  margin-bottom: 120px;
}
.news_content_right_8_1_1{
  color: #014ED5;
  font-size: 24px;
}
.news_content_right_8_1{
  width: 140px;
  height: 48px;
  border-radius: 24px 24px 24px 24px;
  border: 1px solid #014ED5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.news_content_right_8{
  margin-top: 68px;
  width: 100%;
  display: flex;
  justify-content: right;
}
.news_content_right_7{
  color: #a6a9ad;
  margin-top: 32px;
}
.news_content_right_6{
  width: 364px;
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  line-height: 26px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-left: 32px;
  margin-top: 8px;
}
.news_content_right_5{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  line-height: 24px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-left: 32px;
  margin-top: 32px;

}
.news_content_right_4{
  color: #014ED5;
  margin-top: 32px;
}
.news_content_right_3{
  width: 364px;
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 18px;
  color: #014ED5;
  line-height: 26px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-left: 32px;
  margin-top: 8px;
}
.news_content_right_2{

  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 14px;
  color: #014ED5;
  line-height: 24px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-left: 32px;
  margin-top: 32px;
}
.news_content_right_1{
  width: 100%;
  aspect-ratio: 428/248;
  opacity: 0.99;
}
.news_content_right{
  margin-left: 22px;
  width: 38.21%;
}
.news_content_left_3{
  width: 606px;
  height: 26px;
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  line-height: 26px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 8px;
  margin-left: 32px;
margin-bottom: 58px;
}
.news_content_left_2{

  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  line-height: 24px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 32px;
  margin-left: 32px;
}
.news_content_left_1{
  width: 100%;
  /*height: 512px;*/
  aspect-ratio: 670/512;
  opacity: 0.99;
}
.news_content_left{
  background: #F5F9FF;
  opacity: 0.99;
  width: 59.82%;;
}
.news_content{
  display: flex;
  margin-top: 32px;
  width: 100%;
}
.news_tatil_detail{

  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 20px;
  color: #454545;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.news_tatil{

  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.news{
  width: 78%;
}
.homeNews{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  margin-top: 120px;
}
.homeProgramme_right_31{
  width: 140px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  border: 1px solid #014ED5;
}
.homeProgramme_right_3{
  margin-top: 120px;
  width: 100%;
  display: flex;
  justify-content: right;
}
.homeProgramme_right_i{
  width: 45px; /* 圆的宽度 */
  height: 45px; /* 圆的高度 */
  background-color: #5daf34; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  right: 61px;
  top:50%;
}
.homeProgramme_left_i{
  width: 45px; /* 圆的宽度 */
  height: 45px; /* 圆的高度 */
  background-color: #5daf34; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  left: 0px;
  z-index: 100;
  top:50%;
}
.homeProgramme_left_1{
  margin-right: 16px;
  background-color: #F4F8FF;
  width: 31.5%;
}
.homeProgramme{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  margin-top: 120px;
}
.homeProgramme_left{
  display: flex;
  width:  75.69%;;
}
.homeProgramme_right{
  text-align: right;
  width: 24.31%;
}
.homeProduct_left_i{
  width: 45px; /* 圆的宽度 */
  height: 45px; /* 圆的高度 */
  background-color: #5daf34; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  left: 61px;
  z-index: 100;
  top:50%;
}
.homeProduct_right_i {
  width: 45px; /* 圆的宽度 */
  height: 45px; /* 圆的高度 */
  background-color: #5daf34; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  left: -45px;
  top:50%;
  /*transform: translate(-50%, -50%);*/
}
.homeProduct_right_1_3{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 14px;
  color: #454545;
  line-height: 21px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-left: 16px;
  margin-bottom: 32px;
}
.homeProduct_right_1_2 {
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 20px;
  color: #000000;
  line-height: 24px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-top: 32px;
  margin-left: 16px;
}
.homeProduct_image{
  width: 100%;
  /*height: 220px;*/
  aspect-ratio: 268/220;
  opacity: 0.99;
}
.homeProduct_right_1{
  margin-left: 16px;
  width: 31.5%;
  background-color: #F4F8FF;
}
.homeProduct_right{
  display: flex;
  width: 75.69%;
}
.homeProduct_left_3_2{
  color: #014ED5;
  font-size: 20px;
}
.homeProduct_left_31{
  width: 140px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  border: 1px solid #014ED5;
}
.homeProduct_left_3{
  margin-top: 120px;
  width: 100%;
  display: flex;
  justify-content: left;
}
.homeProduct_left_2{
  margin-top: 24px;
}
.homeProduct_left_2_1{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
}
.homeProduct_left_1{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.homeProduct_left{
  text-align: left;
  width: 24.31%;
}
.homeProduct{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  margin-top: 120px;
}
.introduction_right_3_2{
  color: #FFFFFF;
  margin-left: 3px;
}
.introduction_right_3_1{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.introduction_right_3{
  margin-top: 107px;
  width: 100%;
  display: flex;
  justify-content: right;
}
.introduction_right_31{
  width: 140px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;


  background-color: #014ED5;
}
.introduction_right_2{
  margin-top: 24px;
}
.introduction_right_2_1{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: right;
  font-style: normal;
  text-transform: none;
}
.introduction_right{
  text-align: right;
  width: 248px;
}
.introduction_right_1{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: right;
  font-style: normal;
  text-transform: none;
}
.introduction_right_1{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: right;
  font-style: normal;
  text-transform: none;
}
.introduction_left_2{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 14px;
  color: #454545;
  line-height: 26px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 80px;
  white-space: pre-wrap;
}
.introduction_left_1{
  width: 100%;
  aspect-ratio: 856/590;
}
.introduction_image{
  width: 100%;
  height: 100%;
}
.introduction_left{
  width: 76%;
}
.introduction{
  width: 78%;
  display: flex;

  /*align-items: center;*/
}
.homeIntroduction{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
}
.hello{
  background: #FFFFFF;
  width: 100%;
}
.homeImg{
  width: 100%;
}
.image{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue